// extracted by mini-css-extract-plugin
export var actions = "CaseMatcherDebugPanel-module__actions___zZsB7";
export var association = "CaseMatcherDebugPanel-module__association___8oVLA";
export var associations = "CaseMatcherDebugPanel-module__associations___ftH56";
export var columns = "CaseMatcherDebugPanel-module__columns___RZfOI";
export var heading = "CaseMatcherDebugPanel-module__heading___EqLmM";
export var meta = "CaseMatcherDebugPanel-module__meta___tr2Ct";
export var muted = "CaseMatcherDebugPanel-module__muted___+DmzT";
export var output = "CaseMatcherDebugPanel-module__output___wKmMa";
export var panel = "CaseMatcherDebugPanel-module__panel___9XYiu";
export var title = "CaseMatcherDebugPanel-module__title___btoP-";